import type {CreateExtArgs} from '@wix/document-manager-core'
import type {ComponentAfterRootAddDataFromExtEvent} from '../hooks'
import type {DataModelExtensionAPI} from '../../dataModel/dataModel'
import {DATA_TYPES} from '../../../constants/constants'
import _ from 'lodash'
import type {GridLayoutAPI} from '../../gridLayout'

export const adjustLayout = (createExtArgs: CreateExtArgs, data: ComponentAfterRootAddDataFromExtEvent) => {
    const {extensionAPI, pointers, dal} = createExtArgs
    const {containerPointer, compToAddPointer} = data
    const {dataModel} = extensionAPI as DataModelExtensionAPI
    const {shiftItemsToBeUnderTarget, hasGridLayout} = extensionAPI.gridLayout as GridLayoutAPI

    const childrenContainerPointer = pointers.structure.getChildrenContainer(containerPointer!)
    const childrenCompIds = dal.get(childrenContainerPointer)
    const gridChildren = _.filter(childrenCompIds, compId => {
        return hasGridLayout(pointers.getPointer(compId, 'DESKTOP'))
    })
    const index = gridChildren.indexOf(compToAddPointer.id)
    const sectionLayout = dataModel.components.getItem(compToAddPointer, DATA_TYPES.layout)
    const sectionLayoutUpdate = _.filter(sectionLayout.values, {type: 'SingleLayoutData'})
    // eslint-disable-next-line lodash/prefer-filter
    _.forEach(sectionLayoutUpdate, function (layout) {
        if (layout.itemLayout.gridArea) {
            layout.itemLayout.gridArea.rowStart = index + 1
            layout.itemLayout.gridArea.rowEnd = index + 2
            dataModel.addItem(layout, DATA_TYPES.layout, containerPointer.id, layout.id)
        }
    })
    const pageLayout = dataModel.components.getItem(containerPointer, DATA_TYPES.layout)
    const layoutItemsToUpdate = _.filter(pageLayout.values, {type: 'SingleLayoutData'})
    _.forEach(layoutItemsToUpdate, function (layout) {
        layout.containerLayout.rows.push({type: 'auto'})
        dataModel.addItem(layout, DATA_TYPES.layout, containerPointer.id, layout.id)
    })
    shiftItemsToBeUnderTarget(containerPointer, compToAddPointer)
}
